import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { OverlayPanel } from 'primeng';
import { ConfirmationService, LazyLoadEvent } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

import { HeaderService } from './header.service';
import { PasswordChangeMessageService } from '../../services/password-change-message.service';
import { SessionService } from '../../services/session.service';
import { SharedService } from '../../services/shared.service';
import { NotificationDetailsComponent } from '../notification-details/notification-details.component';
import { PreviewAlertComponent } from '../preview-alert/preview-alert.component';

declare var $: any;

@Component({
    selector: 'ib-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, AfterViewInit {
    isLoading: boolean = false;
    userName: string = '';
    userId: string = '';
    lastLoginDate: string = '';
    lastLoginTime: string = '';
    openFullscreen: boolean = false;
    disableHeader: boolean = false;
    disableTime: boolean = false;
    screenWidth: any;
    screenHeight: any;
    status: string = '';
    isNews: boolean = false;
    isOffer: boolean = false;
    isNotice: boolean = false;
    visible: boolean = false;
    notificationCount: number = 0;
    isNotificationListOpen: boolean = false;
    hasNewNotifications = false;
    newNotificationsCount = 0;
    canViewNotificationsCount = false;

    data: any[] = [];
    virtualNotice: any[] = [];
    selectedData: any;
    constructor(
        private sharedService: SharedService,
        private sessionService: SessionService,
        private headerService: HeaderService,
        private route: ActivatedRoute,
        private confirmationService: ConfirmationService,
        public translate: TranslateService,
        public dialogService: DialogService,
        private _passwordChangeMessageService: PasswordChangeMessageService
    ) {}

    ngOnInit(): void {
        if (this.route.snapshot.data['home']) {
            this.route.data.subscribe(data => {
                if (data['home'][1]) {
                    this.userName = data['home'][1].body.userName;
                    this.userId = data['home'][1].body.mobileNo;
                    this.sharedService.setIbUserOid(data['home'][1].body?.ibUserOid);
                    this.formatLastLoginDateTime(data['home'][1].body.lastLoginTime);
                    this.status = data['home'][1].body.status;
                    this.hasNewNotifications = data['home'][2].body.hasNewNotifications;
                    this.newNotificationsCount = data['home'][2].body.newNotificationsCount;
                    this.canViewNotificationsCount = data['home'][2].body.canViewNotificationsCount;
                    data['home'][2].body.hasAlertNotification && sessionStorage.getItem('alertAcknowledged') !== 'yes' && this.viewAlert(data['home'][2].body.alertNotifications[0]);
                    data['home'][1]?.body?.resetMessage && this._passwordChangeMessageService.setMessage(data['home'][1]?.body?.resetMessage);
                }
            });
        }

        this.sharedService.disableSource.asObservable().subscribe(data => {
            if (data != undefined) {
                this.disableHeader = data;
            }
        });

        $('#newsModal').modal();
    }

    ngAfterViewInit(): void {
        this.onResize();
        if (this.screenWidth <= 1366) {
            this.disableTime = true;
        } else {
            this.disableTime = false;
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize(): void {
        this.screenWidth = window.innerWidth;
        this.screenHeight = window.innerHeight;
    }

    formatLastLoginDateTime(transactionDateTime): void {
        let dateTime = transactionDateTime.split(' ');
        this.lastLoginDate = `${dateTime[0]} ${dateTime[1]} ${dateTime[2]} ${dateTime[3]}`;
        this.lastLoginTime = `${dateTime[4]} ${dateTime[5]}`;
    }

    //openOrCloseFullscreen() {

    //    this.openFullscreen = !this.openFullscreen;

    //    if (this.openFullscreen) {
    //        let elem: any = document.documentElement;
    //        if (elem.requestFullscreen) {
    //            elem.requestFullscreen();
    //        } else if (elem.mozRequestFullScreen) { /* Firefox */
    //            elem.mozRequestFullScreen();
    //        } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
    //            elem.webkitRequestFullscreen();
    //        } else if (elem.msRequestFullscreen) { /* IE/Edge */
    //            elem.msRequestFullscreen();
    //        }
    //    }
    //    else {
    //        if ((document as any).exitFullscreen) {
    //            (document as any).exitFullscreen();
    //        } else if ((document as any).mozCancelFullScreen) { /* Firefox */
    //            (document as any).mozCancelFullScreen();
    //        } else if ((document as any).webkitExitFullscreen) { /* Chrome, Safari and Opera */
    //            (document as any).webkitExitFullscreen();
    //        } else if ((document as any).msExitFullscreen) { /* IE/Edge */
    //            (document as any).msExitFullscreen();
    //        }
    //    }
    //}

    toggleMobileSidebar(): void {
        if (document.body.classList.contains('mobile-sidebar-open')) {
            document.body.classList.remove('mobile-sidebar-open');
        } else {
            document.body.classList.add('mobile-sidebar-open');
        }
    }

    onLogoutClick(): void {
        const currentLanguage = this.translate.currentLang;
        this.confirmationService.confirm({
            message: currentLanguage === 'bn' ? 'আপনি নিশ্চিত যে আপনি প্রস্থান করতে চান?' : 'Are you sure you want to logout?',
            accept: () => {
                this.isLoading = true;
                this.sessionService.logout();
            }
        });
    }

    getNotification(): void {
        this.headerService.getNotification().subscribe(response => {
            if (response?.body) {
                this.data = response.body.notifications || [];
                this.notificationCount = response.body.count || 0;
            }
        });
    }

    truncateText(text: string, wordLimit: number): string {
        if (text?.length > wordLimit) {
            return `${text.slice(0, wordLimit)}...`;
        }
        return text;
    }

    toggleNotificationList(event, overlaypanel: OverlayPanel): void {
        this.isNotificationListOpen = !this.isNotificationListOpen;
        if (this.isNotificationListOpen) {
            this.getNotification();
            this.isNotificationListOpen = false;
        }
        overlaypanel.toggle(event);
    }

    loadNotificationLazy(event: LazyLoadEvent): void {
        const start = event.first;
        const end = event.first + event.rows;
        const isDataLoaded = this.virtualNotice.slice(start, end).every(item => item !== undefined);

        if (isDataLoaded) {
            return;
        }

        this.headerService.getNotification(event.first).subscribe(response => {
            if (response) {
                let loadedNotification = response.body?.notifications;
                loadedNotification = loadedNotification.filter(notification => !this.virtualNotice.some(existing => existing?.id === notification?.id));

                Array.prototype.splice.apply(this.virtualNotice, [...[event.first, event.rows], ...loadedNotification]);

                this.virtualNotice = [...this.virtualNotice];
            }
        });
    }

    viewNotificationDetails(data: any): void {
        this.dialogService.open(NotificationDetailsComponent, {
            header: '',
            width: '30%',
            data: data
        });
    }

    viewAlert(data: any): void {
        this.dialogService.open(PreviewAlertComponent, {
            header: '',
            width: '30%',
            data: data
        });
    }
}
